import {
  Builderlyags3ldja2y as Builder,
  Builder3vv3qt9kyowg0 as Builder_0,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.d6d_1 = (new (Builder())('input')).i37();
        this.e6d_1 = (new (Builder())('input')).i37();
        this.f6d_1 = (new (Builder())('input')).i37();
        this.g6d_1 = (new (Builder())('input')).i37();
        this.h6d_1 = (new (Builder())('input')).i37();
        this.i6d_1 = (new (Builder())('input')).i37();
        this.j6d_1 = (new (Builder())('input')).i37();
        this.k6d_1 = (new (Builder())('input')).i37();
        this.l6d_1 = (new (Builder())('input')).i37();
        this.m6d_1 = (new (Builder())('input')).i37();
        this.n6d_1 = (new (Builder())('input')).i37();
        this.o6d_1 = (new (Builder())('input')).i37();
        this.p6d_1 = (new (Builder())('input')).i37();
        this.q6d_1 = (new (Builder())('input')).i37();
        this.r6d_1 = (new (Builder())('input')).i37();
        this.s6d_1 = (new (Builder())('input')).i37();
        this.t6d_1 = (new (Builder())('input')).i37();
        this.u6d_1 = (new (Builder())('input')).i37();
        this.v6d_1 = (new (Builder())('input')).i37();
        this.w6d_1 = (new (Builder_0())('Mutation')).i37();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1m1mmkl5t8eg3,
};
//endregion

//# sourceMappingURL=Mutation.mjs.map
